import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx, withModifiers as _withModifiers, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = { class: "login-brand-panel" }
const _hoisted_3 = { class: "brand-content" }
const _hoisted_4 = { class: "brand-app-name" }
const _hoisted_5 = { class: "login-form-panel" }
const _hoisted_6 = { class: "form-wrapper" }
const _hoisted_7 = { class: "mobile-logo" }
const _hoisted_8 = { class: "mobile-logo-title" }
const _hoisted_9 = { class: "form-row" }
const _hoisted_10 = { class: "remember-me" }
const _hoisted_11 = { class: "form-footer mt-8" }

import { ref, computed } from 'vue'
import { useTitle } from '@/composables/ui/useTitle'
import { useLogin } from '@/composables/auth/useLogin'
import { useForgotPassword } from '@/composables/auth/useForgotPassword'
import { BaseInput, BaseButton, BaseModal } from '@/components/ui'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const appTitle = computed(() => process.env.VUE_APP_TITLE || '')

useTitle(`${appTitle.value} - Login`)

const { email, password, loading, handleLogin } = useLogin()
const rememberMe = ref(false)

// Forgot password modal state
const showForgotModal = ref(false)
const {
  email: resetEmail,
  loading: forgotLoading,
  handleForgotPassword,
  reset: resetForgotForm
} = useForgotPassword()

function handleLoginSubmit() {
  // Clear any previous error before attempting login
  handleLogin()
}

function closeForgotModal() {
  showForgotModal.value = false
  resetForgotForm()
}

async function handleResetPassword() {
  const sent = await handleForgotPassword()
  if (sent) {
    showForgotModal.value = false
    resetForgotForm()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "brand-bg-shapes" }, [
        _createElementVNode("div", { class: "brand-shape shape-1" }),
        _createElementVNode("div", { class: "brand-shape shape-2" }),
        _createElementVNode("div", { class: "brand-shape shape-3" })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "brand-logo" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Logo",
            class: "brand-logo-img"
          })
        ], -1)),
        _createElementVNode("p", _hoisted_4, _toDisplayString(appTitle.value), 1),
        _cache[7] || (_cache[7] = _createElementVNode("h1", { class: "brand-title" }, [
          _createTextVNode("Empowering Abilities,"),
          _createElementVNode("br"),
          _createTextVNode("Transforming Lives.")
        ], -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[9] || (_cache[9] = _createElementVNode("img", {
            src: _imports_0,
            alt: "Logo",
            class: "mobile-logo-img"
          }, null, -1)),
          _createElementVNode("h2", _hoisted_8, _toDisplayString(appTitle.value), 1)
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "form-header" }, [
          _createElementVNode("h2", { class: "form-title" }, "Welcome back"),
          _createElementVNode("p", { class: "form-description" }, "Sign in to your account to continue")
        ], -1)),
        _createElementVNode("form", {
          class: "form-body",
          onSubmit: _withModifiers(handleLoginSubmit, ["prevent"])
        }, [
          _createVNode(_unref(BaseInput), {
            modelValue: _unref(email),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
            label: "Email address",
            type: "email",
            placeholder: "you@example.com",
            autocomplete: "email",
            required: ""
          }, null, 8, ["modelValue"]),
          _createVNode(_unref(BaseInput), {
            modelValue: _unref(password),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(password) ? (password).value = $event : null)),
            label: "Password",
            type: "password",
            placeholder: "••••••••",
            autocomplete: "current-password",
            required: ""
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((rememberMe).value = $event)),
                class: "remember-checkbox"
              }, null, 512), [
                [_vModelCheckbox, rememberMe.value]
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "remember-text" }, "Remember me", -1))
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "forgot-link",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (showForgotModal.value = true))
            }, " Forgot password? ")
          ]),
          _createVNode(_unref(BaseButton), {
            type: "submit",
            variant: "primary",
            size: "lg",
            loading: _unref(loading),
            fullWidth: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(loading) ? 'Signing in...' : 'Sign in'), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ], 32),
        _createElementVNode("p", _hoisted_11, [
          _cache[12] || (_cache[12] = _createTextVNode(" Don't have an account? ")),
          _createVNode(_component_router_link, {
            to: "/register",
            class: "form-footer-link"
          }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode(" Sign up ")
            ])),
            _: 1,
            __: [11]
          })
        ])
      ])
    ]),
    _createVNode(_unref(BaseModal), {
      modelValue: showForgotModal.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showForgotModal).value = $event)),
      title: "Reset your password",
      size: "sm"
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(BaseButton), {
          variant: "ghost",
          onClick: closeForgotModal
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [
            _createTextVNode(" Cancel ")
          ])),
          _: 1,
          __: [14]
        }),
        _createVNode(_unref(BaseButton), {
          variant: "primary",
          loading: _unref(forgotLoading),
          onClick: handleResetPassword
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(forgotLoading) ? 'Sending...' : 'Send reset link'), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-sm text-gray-600 dark:text-gray-400 mb-4" }, " Enter your email address and we'll send you a link to reset your password. ", -1)),
        _createVNode(_unref(BaseInput), {
          modelValue: _unref(resetEmail),
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(resetEmail) ? (resetEmail).value = $event : null)),
          label: "Email address",
          type: "email",
          placeholder: "you@example.com",
          autocomplete: "email"
        }, null, 8, ["modelValue"])
      ]),
      _: 1,
      __: [15]
    }, 8, ["modelValue"])
  ]))
}
}

})